import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const COMMON_ACRONYMS = new Set([
  "url",
  "id",
  "api",
  "html",
  "css",
  "json",
  "xml",
  "sql",
  "pdf",
  "ui",
  "ux",
]);

export function formatPropertyKey(key: string): string {
  return key
    .replace(/_/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/([a-zA-Z])(\d)/g, "$1 $2")
    .split(" ")
    .map((word) => {
      const lower = word.toLowerCase();
      if (COMMON_ACRONYMS.has(lower)) {
        return word.toUpperCase();
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
}
